(function () {
  if (window.__shopagSalesAssistantLoaded) return;
  window.__shopagSalesAssistantLoaded = true;

  const root = document.getElementById("ShopagSalesAssistant");
  if (!root) return;

  const contextNode = root.querySelector(".shopag-chatbot__context");
  const opener = root.querySelector(".shopag-chatbot__opener");
  const openerText = root.querySelector(".shopag-chatbot__opener-text");
  const panel = root.querySelector(".shopag-chatbot__panel");
  const close = root.querySelector(".shopag-chatbot__close");
  const messages = root.querySelector(".shopag-chatbot__messages");
  const guides = root.querySelector(".shopag-chatbot__guides");
  const form = root.querySelector(".shopag-chatbot__form");
  const input = root.querySelector("#ShopagSalesAssistantInput");
  const apiUrl = root.dataset.apiUrl || "/storefront/shopify-ai-chatbot";

  let pageContext = {};
  try {
    pageContext = JSON.parse(contextNode ? contextNode.textContent : "{}");
  } catch (err) {
    pageContext = {};
  }

  const state = {
    enabled: false,
    sessionId: window.localStorage.getItem("shopag_chatbot_session") || "",
    experimentId: "",
    variantId: "",
    cartId: window.localStorage.getItem("shopag_chatbot_cart_id") || "",
  };

  function sessionId() {
    if (!state.sessionId) {
      state.sessionId = "web_" + Math.random().toString(16).slice(2) + Date.now().toString(16);
      try {
        window.localStorage.setItem("shopag_chatbot_session", state.sessionId);
      } catch (err) {
        /* storage unavailable */
      }
    }
    return state.sessionId;
  }

  async function post(payload, options) {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "x-shopag-session": sessionId(),
      },
      signal: options && options.signal,
      body: JSON.stringify({
        session_id: sessionId(),
        context: pageContext,
        page_url: pageContext.page_url || window.location.href,
        experiment_id: state.experimentId,
        variant_id: state.variantId,
        ...payload,
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.ok === false) {
      const error = new Error(data.message || data.error_code || "request_failed");
      error.payload = data;
      throw error;
    }
    return data;
  }

  function logEvent(eventType, extra) {
    post({ action: "event", event_type: eventType, extra: extra || {} }).catch(function () {});
  }

  function addMessage(role, text) {
    const node = document.createElement("div");
    node.className = "shopag-chatbot__message shopag-chatbot__message--" + role;
    node.textContent = text;
    messages.appendChild(node);
    messages.scrollTop = messages.scrollHeight;
  }

  function setGuides(actions) {
    guides.innerHTML = "";
    (actions || []).forEach(function (label) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "shopag-chatbot__guide";
      button.textContent = label;
      button.addEventListener("click", function () {
        void sendMessage(label);
      });
      guides.appendChild(button);
    });
  }

  async function sendMessage(text) {
    const message = String(text || "").trim();
    if (!message) return;
    addMessage("user", message);
    logEvent("chat_submitted", { message_length: message.length });
    input.value = "";
    input.disabled = true;
    try {
      const data = await post({ action: "chat", message: message });
      addMessage("assistant", data.reply || "I can help you choose from this page.");
      if (Array.isArray(data.products) && data.products.length === 1 && /add to cart/i.test(message)) {
        const product = data.products[0];
        if (product.variant_id) {
          await addToCart(product.variant_id, 1);
        }
      }
    } catch (err) {
      addMessage("assistant", "I could not answer that safely. Shopify Inbox is still available for support help.");
    } finally {
      input.disabled = false;
      input.focus();
    }
  }

  async function addToCart(variantId, quantity) {
    const data = await post({
      action: "cart_add",
      variant_id: variantId,
      quantity: quantity || 1,
      cart_id: state.cartId || undefined,
    });
    if (data.cart_id) {
      state.cartId = data.cart_id;
      try {
        window.localStorage.setItem("shopag_chatbot_cart_id", data.cart_id);
      } catch (err) {
        /* storage unavailable */
      }
    }
    logEvent("product_added_to_cart", { checkout_url: data.checkout_url });
    addMessage("assistant", data.checkout_url ? "Added. Ready to checkout when you are: " + data.checkout_url : "Added to cart.");
  }

  function openPanel() {
    if (!state.enabled) return;
    panel.hidden = false;
    root.classList.add("shopag-chatbot--open");
    opener.setAttribute("aria-expanded", "true");
    logEvent("chat_opened", {});
    if (!messages.children.length) {
      addMessage("assistant", "Tell me what matters most and I will narrow this page down.");
    }
    input.focus();
  }

  function closePanel() {
    panel.hidden = true;
    root.classList.remove("shopag-chatbot--open");
    opener.setAttribute("aria-expanded", "false");
    opener.focus();
  }

  opener.addEventListener("click", function () {
    if (panel.hidden) openPanel();
    else closePanel();
  });
  close.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    closePanel();
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !panel.hidden) closePanel();
  });
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    void sendMessage(input.value);
  });

  function bootstrap() {
    const controller = window.AbortController ? new AbortController() : null;
    const timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 3500);
    post({ action: "bootstrap" }, { signal: controller && controller.signal })
      .then(function (data) {
        window.clearTimeout(timeout);
      if (!data.enabled) return;
      state.enabled = true;
      state.sessionId = data.session_id || sessionId();
      state.experimentId = data.experiment_id || "";
      state.variantId = data.variant_id || "";
      openerText.textContent = data.opener || "Want help shopping?";
      setGuides(data.guided_actions || []);
      root.hidden = false;
      logEvent("opener_impression", { context_scope: data.context_scope });
    })
    .catch(function () {
      window.clearTimeout(timeout);
      root.hidden = true;
    });
  }

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(bootstrap, { timeout: 1800 });
  } else {
    window.setTimeout(bootstrap, 600);
  }
})();
